import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";

const AcceptInvite = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token") || "";

    const [name, setName] = useState("");
    const [password, setPassword] = useState("");
    const [status, setStatus] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setStatus("");
        setError("");

        try {
            const res = await fetch("/api/invites/accept", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ token, name, password })
            });

            const data = await res.json();

            if (!res.ok) {
                setError(data.message || "Failed to accept invite.");
                return;
            }

            setStatus("Account created successfully. Redirecting to login...");
            setTimeout(() => navigate("/login"), 1500);
        } catch (err) {
            console.error("Accept invite error:", err);
            setError("Server error.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24 }}>
            <div style={{ width: "100%", maxWidth: 460, background: "#fff", border: "1px solid #ddd", borderRadius: 20, padding: 28 }}>
                <h1>Accept Invite</h1>
                <p>Create your Kuddlecore account.</p>

                <form onSubmit={handleSubmit} style={{ display: "grid", gap: 14 }}>
                    <input
                        type="text"
                        placeholder="Full name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />

                    <input
                        type="password"
                        placeholder="Create password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />

                    <button type="submit" disabled={submitting}>
                        {submitting ? "Creating account..." : "Create Account"}
                    </button>
                </form>

                {status ? <p style={{ color: "green" }}>{status}</p> : null}
                {error ? <p style={{ color: "crimson" }}>{error}</p> : null}

                <div style={{ marginTop: 16 }}>
                    <Link to="/login">Back to Login</Link>
                </div>
            </div>
        </div>
    );
};

export default AcceptInvite;